module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/mobile/2.png?a18b27582d3227a894a9df5daee32c36";